/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetDictionaryDto,
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
    GetJudgmentDto,
    GetJudgmentDtoFromJSON,
    GetJudgmentDtoFromJSONTyped,
    GetJudgmentDtoToJSON,
    GetOrganizationalUnitDto,
    GetOrganizationalUnitDtoFromJSON,
    GetOrganizationalUnitDtoFromJSONTyped,
    GetOrganizationalUnitDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetKwzDto
 */
export interface GetKwzDto {
    /**
     * 
     * @type {string}
     * @memberof GetKwzDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetKwzDto
     */
    publicationNumber: number;
    /**
     * 
     * @type {Date}
     * @memberof GetKwzDto
     */
    publicationDate?: Date;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetKwzDto
     */
    decisionSign: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetKwzDto
     */
    decisionIndex: GetDictionaryDto;
    /**
     * 
     * @type {string}
     * @memberof GetKwzDto
     */
    productionCountry: string;
    /**
     * 
     * @type {string}
     * @memberof GetKwzDto
     */
    incompatibility: string;
    /**
     * 
     * @type {string}
     * @memberof GetKwzDto
     */
    danger: string;
    /**
     * 
     * @type {string}
     * @memberof GetKwzDto
     */
    buyBackOrder: string;
    /**
     * 
     * @type {string}
     * @memberof GetKwzDto
     */
    destructionOrder: string;
    /**
     * 
     * @type {string}
     * @memberof GetKwzDto
     */
    other: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetKwzDto
     */
    approved: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetKwzDto
     */
    tariffCode: string;
    /**
     * 
     * @type {GetOrganizationalUnitDto}
     * @memberof GetKwzDto
     */
    organizationalUnit: GetOrganizationalUnitDto;
    /**
     * 
     * @type {GetJudgmentDto}
     * @memberof GetKwzDto
     */
    judgment: GetJudgmentDto;
    /**
     * 
     * @type {string}
     * @memberof GetKwzDto
     */
    productBatchNumber: string;
    /**
     * 
     * @type {string}
     * @memberof GetKwzDto
     */
    withdrawalInfo: string;
    /**
     * 
     * @type {string}
     * @memberof GetKwzDto
     */
    removalIncompatibility: string;
    /**
     * 
     * @type {string}
     * @memberof GetKwzDto
     */
    stopActivity: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetKwzDto
     */
    request: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetKwzDto
     */
    requestApproved: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetKwzDto
     */
    requestDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetKwzDto
     */
    removePublishDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetKwzDto
     */
    approvedDate?: Date | null;
}

export function GetKwzDtoFromJSON(json: any): GetKwzDto {
    return GetKwzDtoFromJSONTyped(json, false);
}

export function GetKwzDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetKwzDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'publicationNumber': json['publicationNumber'],
        'publicationDate': !exists(json, 'publicationDate') ? undefined : (new Date(json['publicationDate'])),
        'decisionSign': GetDictionaryDtoFromJSON(json['decisionSign']),
        'decisionIndex': GetDictionaryDtoFromJSON(json['decisionIndex']),
        'productionCountry': json['productionCountry'],
        'incompatibility': json['incompatibility'],
        'danger': json['danger'],
        'buyBackOrder': json['buyBackOrder'],
        'destructionOrder': json['destructionOrder'],
        'other': json['other'],
        'approved': json['approved'],
        'tariffCode': json['tariffCode'],
        'organizationalUnit': GetOrganizationalUnitDtoFromJSON(json['organizationalUnit']),
        'judgment': GetJudgmentDtoFromJSON(json['judgment']),
        'productBatchNumber': json['productBatchNumber'],
        'withdrawalInfo': json['withdrawalInfo'],
        'removalIncompatibility': json['removalIncompatibility'],
        'stopActivity': json['stopActivity'],
        'request': json['request'],
        'requestApproved': json['requestApproved'],
        'requestDate': !exists(json, 'requestDate') ? undefined : (json['requestDate'] === null ? null : new Date(json['requestDate'])),
        'removePublishDate': !exists(json, 'removePublishDate') ? undefined : (json['removePublishDate'] === null ? null : new Date(json['removePublishDate'])),
        'approvedDate': !exists(json, 'approvedDate') ? undefined : (json['approvedDate'] === null ? null : new Date(json['approvedDate'])),
    };
}

export function GetKwzDtoToJSON(value?: GetKwzDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'publicationNumber': value.publicationNumber,
        'publicationDate': value.publicationDate === undefined ? undefined : (value.publicationDate.toISOString()),
        'decisionSign': GetDictionaryDtoToJSON(value.decisionSign),
        'decisionIndex': GetDictionaryDtoToJSON(value.decisionIndex),
        'productionCountry': value.productionCountry,
        'incompatibility': value.incompatibility,
        'danger': value.danger,
        'buyBackOrder': value.buyBackOrder,
        'destructionOrder': value.destructionOrder,
        'other': value.other,
        'approved': value.approved,
        'tariffCode': value.tariffCode,
        'organizationalUnit': GetOrganizationalUnitDtoToJSON(value.organizationalUnit),
        'judgment': GetJudgmentDtoToJSON(value.judgment),
        'productBatchNumber': value.productBatchNumber,
        'withdrawalInfo': value.withdrawalInfo,
        'removalIncompatibility': value.removalIncompatibility,
        'stopActivity': value.stopActivity,
        'request': value.request,
        'requestApproved': value.requestApproved,
        'requestDate': value.requestDate === undefined ? undefined : (value.requestDate === null ? null : value.requestDate.toISOString()),
        'removePublishDate': value.removePublishDate === undefined ? undefined : (value.removePublishDate === null ? null : value.removePublishDate.toISOString()),
        'approvedDate': value.approvedDate === undefined ? undefined : (value.approvedDate === null ? null : value.approvedDate.toISOString()),
    };
}


